import { useState } from "react";
import { COLORS } from "../constants";

export default function DriveView({
  driveAccounts, activeDriveAccountId, setActiveDriveAccountId, driveFiles,
  driveMessage, setDriveMessage, importingDrive, importDriveFile, fetchDriveFiles,
  connectGoogleDrive, disconnectDriveAccount, checkDriveStatus, files
}) {
  const [confirmingDisconnectId, setConfirmingDisconnectId] = useState(null);

  if (driveAccounts.length === 0) return (
    <div style={{ textAlign: "center", padding: "60px 20px" }}>
      <div style={{ width: "56px", height: "56px", margin: "0 auto 16px", background: COLORS.blueLight, borderRadius: "14px", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <svg width="28" height="28" viewBox="0 0 24 24" fill={COLORS.blue}><path d="M7.71 3.5L1.15 15l3.43 5.5h13.84l3.43-5.5-6.56-11.5H7.71zm.57 1h7.44l5.7 10H2.58l5.7-10zM5.01 16h13.98l-2.5 4H7.51l-2.5-4z" /></svg>
      </div>
      <p style={{ fontSize: "16px", fontWeight: "500", color: COLORS.textPrimary, marginBottom: "8px" }}>Connect Google Drive</p>
      <p style={{ fontSize: "13px", color: COLORS.textSecondary, marginBottom: "24px" }}>Import your course materials directly from Google Drive without uploading them manually. You can connect multiple Google accounts if your files are spread across them.</p>
      <button onClick={connectGoogleDrive} style={{ padding: "10px 24px", background: COLORS.blue, color: "white", border: "none", borderRadius: "8px", fontSize: "14px", cursor: "pointer", fontWeight: "500" }}>Connect Google Drive</button>
    </div>
  );

  const activeAccount = driveAccounts.find(a => a.id === activeDriveAccountId);

  const handleSwitchAccount = (accountId) => {
    setActiveDriveAccountId(accountId);
    setDriveMessage("");
    fetchDriveFiles(accountId);
  };

  const handleDisconnect = async (accountId) => {
    await disconnectDriveAccount(accountId);
    setConfirmingDisconnectId(null);
  };

  return (
    <div>
      {/* Connected accounts list */}
      <div style={{ display: "flex", flexDirection: "column", gap: "6px", marginBottom: "16px" }}>
        {driveAccounts.map(account => (
          <div key={account.id} style={{ display: "flex", alignItems: "center", gap: "10px", padding: "9px 12px", background: account.id === activeDriveAccountId ? COLORS.blueLight : COLORS.bg, border: `0.5px solid ${account.id === activeDriveAccountId ? COLORS.blue : COLORS.border}`, borderRadius: "8px" }}>
            <span style={{ width: "8px", height: "8px", background: "#22c55e", borderRadius: "50%", display: "inline-block", flexShrink: 0 }} />
            <span onClick={() => handleSwitchAccount(account.id)} style={{ flex: 1, fontSize: "13px", color: COLORS.textPrimary, cursor: "pointer", fontWeight: account.id === activeDriveAccountId ? "500" : "400" }}>
              {account.email}
            </span>
            {account.id === activeDriveAccountId && <span style={{ fontSize: "11px", color: COLORS.blue, flexShrink: 0 }}>Browsing</span>}
            {confirmingDisconnectId === account.id ? (
              <div style={{ display: "flex", gap: "6px", flexShrink: 0 }}>
                <span onClick={() => setConfirmingDisconnectId(null)} style={{ fontSize: "12px", color: COLORS.textTertiary, cursor: "pointer" }}>Cancel</span>
                <span onClick={() => handleDisconnect(account.id)} style={{ fontSize: "12px", color: COLORS.danger, cursor: "pointer", fontWeight: "500" }}>Confirm disconnect</span>
              </div>
            ) : (
              <span onClick={() => setConfirmingDisconnectId(account.id)} style={{ fontSize: "12px", color: COLORS.textTertiary, cursor: "pointer", flexShrink: 0 }}>Disconnect</span>
            )}
          </div>
        ))}
        <button onClick={connectGoogleDrive} style={{ padding: "8px 14px", fontSize: "12px", background: "transparent", border: `0.5px dashed ${COLORS.border}`, borderRadius: "8px", color: COLORS.textSecondary, cursor: "pointer", alignSelf: "flex-start" }}>
          + Connect another account
        </button>
      </div>

      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "16px" }}>
        <span style={{ fontSize: "13px", color: COLORS.textSecondary }}>
          Browsing files in <strong>{activeAccount?.email}</strong>
        </span>
        <button onClick={() => fetchDriveFiles()} style={{ padding: "6px 14px", fontSize: "12px", background: "transparent", border: `0.5px solid ${COLORS.border}`, borderRadius: "6px", color: COLORS.textSecondary, cursor: "pointer" }}>Refresh files</button>
      </div>
      {driveMessage && <div style={{ padding: "8px 14px", background: "#f0fdf4", border: `0.5px solid #86efac`, borderRadius: "8px", fontSize: "13px", color: COLORS.success, marginBottom: "12px" }}>{driveMessage}</div>}
      {driveFiles.length === 0 ? (
        <div style={{ textAlign: "center", padding: "40px 20px" }}>
          <p style={{ fontSize: "14px", color: COLORS.textSecondary, marginBottom: "8px" }}>No compatible files found</p>
          <p style={{ fontSize: "13px", color: COLORS.textTertiary, marginBottom: "16px" }}>We look for PDF, Word, and PowerPoint files in your Drive</p>
          <button onClick={() => fetchDriveFiles()} style={{ padding: "8px 20px", background: COLORS.blueLight, color: COLORS.blue, border: `0.5px solid ${COLORS.blueMid}`, borderRadius: "8px", fontSize: "13px", cursor: "pointer" }}>Load Drive files</button>
        </div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
          {driveFiles.map(f => {
            const alreadyImported = files.some(sf => sf.filename === f.name);
            return (
              <div key={f.id} style={{ display: "flex", alignItems: "center", gap: "10px", padding: "9px 12px", background: COLORS.bg, border: `0.5px solid ${COLORS.border}`, borderRadius: "8px" }}>
                <div style={{ width: "32px", height: "32px", borderRadius: "8px", background: COLORS.blueLight, display: "flex", alignItems: "center", justifyContent: "center", fontSize: "14px", flexShrink: 0 }}>{f.name.endsWith(".pdf") ? "📄" : f.name.endsWith(".pptx") ? "📊" : "📝"}</div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: "13px", color: COLORS.textPrimary, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{f.name}</div>
                  <div style={{ fontSize: "11px", color: COLORS.textTertiary }}>Modified: {new Date(f.modifiedTime).toLocaleDateString()}</div>
                </div>
                <div style={{ flexShrink: 0 }}>
                  {alreadyImported ? <span style={{ fontSize: "12px", color: COLORS.success }}>✓ Imported</span> : <button onClick={() => importDriveFile(f.id, f.name)} disabled={importingDrive[f.id]} style={{ padding: "5px 14px", fontSize: "12px", background: importingDrive[f.id] ? COLORS.bgTertiary : COLORS.blueLight, color: COLORS.blue, border: `0.5px solid ${COLORS.blueMid}`, borderRadius: "6px", cursor: importingDrive[f.id] ? "default" : "pointer" }}>{importingDrive[f.id] ? "Importing..." : "Import"}</button>}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}